module.exports = __webpack_public_path__ + "static/media/ATOM.aa891983.svg";